import {
  isNotNull,
  isNumber,
  isNumberOrNull,
  isValidEmail,
  isValidJapanTelNumber,
  isValidPostalCode,
  isValidTelNumber,
  stringDoesNotIncludeDash,
} from "../../utils/validation";
const fieldTranslations = {
  buyerNo: "買人No",
  buyerName: "買人名",
  buyerNameFurigana: "買人フリガナ",
  receiptDivisionCd: "入金区分",
  closingDateGroupCd: "締日グループ",
  postCode: "郵便番号",
  address: "住所",
  tel: "TEL",
  fax: "FAX",
  email: "メール",
  businessRegistrationNo: "事業者登録番号",
  billingCd: "請求先コード",
  statisticsCd: "統計先コード",
};

const buyerValidationRules = {
  buyerNo: [isNumber, isNotNull],
  buyerName: [isNotNull],
  // buyerNameFurigana: "買人フリガナ",
  receiptDivisionCd: [isNumber, isNotNull],
  closingDateGroupCd: [isNumberOrNull],
  // postCode: [isValidPostalCode],
  // address: "住所",
  // tel: [isValidJapanTelNumber],
  // fax: [isValidJapanTelNumber],
  email: [isValidEmail],
  businessRegistrationNo: [stringDoesNotIncludeDash],
  billingCd: [isNumberOrNull],
  statisticsCd: [isNumberOrNull],
};

export default function validateBuyer(buyerInfo) {
  let errors = [];

  for (const key in buyerValidationRules) {
    const fieldRules = buyerValidationRules[key];
    fieldRules.forEach((rule) => {
      if (!rule(buyerInfo[key])) {
        const translatedFieldName = fieldTranslations[key] || key;
        errors.push(`${translatedFieldName}の値が無効です。`);
      }
    });
  }
  //ユニークエラー一覧を返す
  return Array.from(new Set(errors));
}
